import * as React from 'react';

import TabsSection from 'components/tabs/tabs-section/TabsSection';
import CampaignsTableByState from './CampaignsTableByState';

import { t } from 'utils/language';
import { ORGANIZATION_PROFILE_TYPE_INFLUENCER } from 'utils/organization';
import { TYPES, TYPE_PENDING } from 'utils/influencer-subcampaigns';

import type {
  ApprovalStatus,
  CampaignWithSubcampaignMeta,
  DeliverablesOverdueBySubcampaignIdLocal,
  Pagination,
  Subcampaign
} from 'types';

type Props = {
  activeCampaignState: string,
  influencerId: number,
  influencerSubcampaignsIsLoading: boolean,
  influencerSubcampaignsList: Array<Subcampaign>,
  influencerSubcampaignsPagination: Pagination,
  influencerSubcampaignsCounts: {
    [x: string]: number
  },
  hasProfileBoost: boolean,
  organizationId: number,
  overdueDeliverables: DeliverablesOverdueBySubcampaignIdLocal,
  onActiveCampaignStateChange: (a?: string | null) => void,
  onPageChange: (page: number) => void,
  influencerStatus: ApprovalStatus
};

class CampaignsTableInfluencerContainer extends React.PureComponent<Props> {
  getAdaptedSubcampaignsList(subcampaignsList: Array<Subcampaign>): Array<CampaignWithSubcampaignMeta> {
    return subcampaignsList.map((subcampaign) => {
      const { campaign } = subcampaign;

      return {
        ...campaign,
        subcampaignMeta: subcampaign
      };
    });
  }

  render(): React.ReactNode {
    const {
      organizationId,
      influencerId,
      influencerStatus,
      hasProfileBoost,
      overdueDeliverables,
      activeCampaignState,
      influencerSubcampaignsIsLoading,
      influencerSubcampaignsList,
      influencerSubcampaignsPagination,
      influencerSubcampaignsCounts,
      onActiveCampaignStateChange,
      onPageChange
    } = this.props;

    if (!organizationId) {
      return null;
    }

    const campaignsList = this.getAdaptedSubcampaignsList(influencerSubcampaignsList);
    const availableTypes = influencerStatus === 'rejected'
      ? TYPES.filter(type => type !== TYPE_PENDING)
      : TYPES;

    const influencerTabs = availableTypes.map(type => ({
      identifier: type,
      label: `${t(`campaigns_table.subcampaign_${type}_label`)} (${influencerSubcampaignsCounts[type]})`,
      className: `campaigns-table-tabs__item--type-${type}`,
      activeClassName: `campaigns-table-tabs__item--type-${type}-active`
    }));

    return (
      <div className="campaigns-table-tabs">
        <TabsSection
          activeTab={activeCampaignState}
          onClick={onActiveCampaignStateChange}
          items={influencerTabs}
        />
        <CampaignsTableByState
          influencerId={influencerId}
          hasProfileBoost={hasProfileBoost}
          profileType={ORGANIZATION_PROFILE_TYPE_INFLUENCER}
          activeTab={activeCampaignState}
          campaignsIsLoading={influencerSubcampaignsIsLoading}
          campaignsList={campaignsList}
          campaignsPagination={influencerSubcampaignsPagination}
          overdueDeliverables={overdueDeliverables}
          handlePageChanged={onPageChange}
          influencerStatus={influencerStatus}
          influencerSubcampaignsCounts={influencerSubcampaignsCounts}
        />
      </div>
    );
  }
}

export default CampaignsTableInfluencerContainer;
